import { createGlobalStyle } from 'styled-components';
import { tokens } from './tokens';

export const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }
  html { height: 100%; }
  html, body, #root {
    margin: 0;
    min-height: 100%;
    font-family: ${tokens.typography.fontFamily};
    color: ${tokens.colors.text};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    background: linear-gradient(to bottom, rgb(85, 2, 37), rgb(142, 3, 61)) fixed;
  }
  #root { min-height: 100vh; display: flex; flex-direction: column; }
  a { color: ${tokens.colors.primary}; text-decoration: none; }
  a:focus { outline: 2px solid ${tokens.colors.accent}; outline-offset: 2px; }
  :focus-visible { outline: 2px solid ${tokens.colors.primary}; outline-offset: 2px; }
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after { animation-duration: 0.001ms !important; animation-iteration-count: 1 !important; transition-duration: 0.001ms !important; }
  }
  .skip-link {
    position: absolute;
    left: -999px;
    top: -999px;
  }
  .skip-link:focus {
    left: ${tokens.spacing.xl};
    top: ${tokens.spacing.xl};
    background: ${tokens.colors.surface};
    color: ${tokens.colors.text};
    padding: ${tokens.spacing.sm} ${tokens.spacing.md};
    border-radius: ${tokens.radius.xs};
    box-shadow: ${tokens.shadow.sm};
  }
`;